<template>
  <v-container fill-height>
    <v-layout row wrap align-center>
      <v-flex>
        <v-avatar
          width="400px"
          height="216px"
          class="profile rounded-lg mx-4"
          @click="openCropper"
        >
          <image-cropper v-model="showCropperModal" @change="onChangeImage" />

          <div class="banner-container" v-if="site || bannerImage">
            <v-img
              :src="site && !imageChanged ? site.bannerSource : bannerImage"
            ></v-img>
          </div>
          <div class="banner-container pt-8" v-else>
            <v-icon class="mt-10 mb-1" size="50">{{ icons.camera }}</v-icon>
            <div class="grey--text text--darken-2 subtitle-2">
              Upload Image
            </div>
          </div>
        </v-avatar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { mdiCamera } from '@mdi/js'
import ImageCropper from '@/components/modals/ImageCropper'

export default {
  components: {
    ImageCropper
  },

  computed: {
    ...mapState({
      site: state => state.site.siteDetails
    })
  },

  data() {
    return {
      showCropperModal: false,
      imageChanged: false,
      bannerImage: null,
      icons: {
        camera: mdiCamera
      }
    }
  },

  methods: {
    openCropper() {
      this.showCropperModal = true
    },

    onChangeImage(blob, image) {
      this.imageChanged = true
      this.bannerImage = image
      this.$emit('change', blob)
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-container {
  background-color: #f0f3f4;
  width: 400px;
  height: 216px;
  box-shadow: 4px 4px 25px #a9a9a9;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
</style>
